export default __webpack_public_path__ + "static/media/ah.d2e8b0c6.svg";